/* Optional measurement: never owns purchase state, never delays navigation. */
(() => {
  if (window.MettaMeasurement) return;
  let config;
  try { config = JSON.parse(document.querySelector('[data-v2-measurement-config]').textContent); } catch { return; }
  const debug = config.themeRole !== 'main' && new URL(location.href).searchParams.get('v2_measure') === 'debug';
  const live = config.themeRole === 'main' && !window.Shopify?.designMode;
  const names = new Set(['view', 'category_changed', 'quantity_changed', 'purchase_type_changed', 'interval_changed', 'flavor_opened', 'gallery_changed', 'section_viewed', 'cart_add_started', 'cart_add_succeeded', 'cart_add_failed', 'cart_opened', 'cart_changed', 'cart_action_failed', 'checkout_redirect']);
  const keys = new Set(['family', 'previous_family', 'source', 'variant_id', 'quantity', 'bag_count', 'line_count', 'purchase_type', 'weeks', 'slide', 'section', 'attempt', 'stage', 'action', 'currency', 'total_minor', 'rules_mode']);
  const queue = [], log = [], viewed = new Set();
  let pageId, observer;
  const consent = () => window.Cookiebot?.consent?.statistics === true;
  const enabled = () => (debug || live) && consent();
  const context = root => {
    root = root?.closest?.('[data-v2-pdp], [data-v2-cart-root]') || document.querySelector('[data-v2-pdp], [data-v2-cart-root]');
    return { family: root?.dataset.activeFamily, rules_mode: root?.dataset.rulesMode };
  };
  function send(event) {
    if (!enabled() || !live || !window.__mettaMixpanelReady || typeof window.mixpanel?.track !== 'function') return false;
    try {
      if (window.mixpanel.has_opted_out_tracking?.()) return false;
      window.mixpanel.track(event.name, event.properties, event.name === 'MËTTA V2 checkout_redirect' ? { transport: 'sendBeacon', send_immediately: true } : {});
      return true;
    } catch { return false; }
  }
  function track(name, properties = {}, root) {
    try {
      if (!names.has(name) || !enabled()) return false;
      pageId ||= window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
      const clean = {};
      for (const [key, value] of Object.entries({ ...context(root), ...properties })) {
        if (keys.has(key) && ((typeof value === 'number' && Number.isFinite(value)) || typeof value === 'boolean' || typeof value === 'string')) clean[key] = typeof value === 'string' ? value.slice(0, 80) : value;
      }
      const event = { name: `MËTTA V2 ${name}`, properties: { ...clean, schema_version: 1, flow_version: 'mix_match_v1', environment: live ? 'live' : 'staging', theme_id: String(config.themeId), page_path: location.pathname, page_id: pageId } };
      if (debug) { log.push(event); if (log.length > 100) log.shift(); return true; }
      if (!send(event)) {
        // Preserve the initial exposure during a slow SDK load, even after many clicks.
        if (queue.length >= 50) queue.splice(queue[0]?.name === 'MËTTA V2 view' ? 1 : 0, 1);
        queue.push(event);
      }
      return true;
    } catch { return false; }
  }
  function observe() {
    if (!enabled()) return;
    const root = document.querySelector('[data-v2-pdp]');
    if (root?.dataset.activeFamily && !viewed.has('pdp')) {
      if (track('view', { family: root.dataset.activeFamily }, root)) viewed.add('pdp');
    }
    if (!window.IntersectionObserver) return;
    observer ||= new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.1 || !entry.target.getClientRects().length || entry.target.closest('[hidden]')) continue;
        const node = entry.target;
        const family = node.dataset.v2ContentFamily || node.dataset.v2CategoryStory || root?.dataset.activeFamily;
        const section = node.dataset.v2EditorialKind || (node.hasAttribute('data-v2-category-story') ? 'category_story' : node.hasAttribute('data-v2-reviews') ? 'reviews' : 'buybox');
        const key = `${family}:${section}`;
        if (!viewed.has(key) && track('section_viewed', { section, family }, root)) viewed.add(key);
      }
    }, { threshold: 0.1 });
    observer.disconnect();
    document.querySelectorAll('.v2-buybox, [data-v2-editorial-kind], [data-v2-category-story], [data-v2-reviews]').forEach(node => observer.observe(node));
  }
  function sync() {
    if (!enabled()) {
      for (const event of queue) {
        if (event.name === 'MËTTA V2 view') viewed.delete('pdp');
        if (event.name === 'MËTTA V2 section_viewed') viewed.delete(`${event.properties.family}:${event.properties.section}`);
      }
      queue.length = 0; log.length = 0; observer?.disconnect(); return;
    }
    if (live && window.__mettaMixpanelReady) {
      const waiting = queue.splice(0);
      waiting.forEach(event => { if (!send(event)) queue.push(event); });
    }
    observe();
  }
  window.MettaMeasurement = { track, debugEvents: () => debug ? JSON.parse(JSON.stringify(log)) : [], status: () => ({ environment: live ? 'live' : 'staging', debug, consent: consent(), ready: !!window.__mettaMixpanelReady, queued: queue.length }) };
  ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline', 'metta:mixpanel-ready'].forEach(name => window.addEventListener(name, sync));
  document.addEventListener('v2:content-ready', observe);
  document.addEventListener('v2:family-change', observe);
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:unload', () => observer?.disconnect());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true }); else sync();
})();
